<ng-container *ngIf="serverError">
  <div class="modal-header">
    <h4 class="modal-title">Server Error: {{ serverError }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</ng-container>

<ng-container *ngIf="!serverError">

  <div class="modal-header">
    <h4 class="modal-title">Add Membership to Sale</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">

    <div class="form-group">
      <label for="product_type_id">Membership Type</label>
      <select id="product_type_id"
              name="product_type_id"
              class="custom-select"
              [(ngModel)]="lineItem.product_type_id"
              (ngModelChange)="handleMembershipTypeChange()"
              [disabled]="loadingSubmit"
              [class.disabled]="loadingSubmit">
        <option [ngValue]="null">---</option>
        <option *ngFor="let membership of memberships"
                [ngValue]="membership.id">
          {{ membership.name }}
        </option>
      </select>
      <small class="form-text text-muted">
        Only prepaid individual memberships may be sold via the Sell Screen.
      </small>
    </div>

    <div class="form-group">
      <p class="mb-2">Assigned Customer</p>

      <p *ngIf="lineItem.customer_id !== null" class="indented-subsection">
        <b>{{ lineItem.customer_first_name }} {{ lineItem.customer_last_name }}</b>
        <br>
        {{ dateStringFromISO8601(lineItem.customer_birthday) }}
        <br>
        <span *ngIf="lineItem.customer_email">
          {{ lineItem.customer_email }}
        </span>
        <span *ngIf="!lineItem.customer_email" class="text-muted">
          No email address
        </span>
      </p>

      <button class="btn btn-sm btn-primary mb-2"
              type="button"
              [disabled]="loadingSubmit || purchasingCustomerIsAssigned()"
              [class.disabled]="loadingSubmit || purchasingCustomerIsAssigned()"
              (click)="assignPurchasingCustomer()">
        {{ purchasingCustomerIsAssigned() ? 'Purchasing Customer Selected' : 'Select Purchasing Customer' }}
      </button>
      <br>
      <button class="btn btn-sm btn-primary mb-2"
              type="button"
              [disabled]="loadingSubmit"
              [class.disabled]="loadingSubmit"
              (click)="openSelectCustomerModal()">
        Select Other Customer
      </button>
      <br>
      <button class="btn btn-sm btn-primary"
              type="button"
              [disabled]="loadingSubmit"
              [class.disabled]="loadingSubmit"
              (click)="openCreateCustomerModal()">
        Create New Customer
      </button>
    </div>

    <ng-container *ngIf="getSelectedMembership() !== null">

      <div class="form-group" *ngIf="getSelectedMembership().has_fixed_date_ranges">
        <label for="product_date_range">Date Range</label>
        <select class="custom-select"
                id="product_date_range"
                name="product_date_range"
                [(ngModel)]="lineItem.product_date_range">
          <option [ngValue]="undefined"
                  class="text-muted disabled"
                  disabled>
            Select a Date Range
          </option>
          <option *ngFor="let dro of getSelectedMembershipFilteredDateRanges()"
                  [ngValue]="dro.start_date + ':' + dro.end_date">
            {{ dateStringFromISO8601(dro.start_date) }} - {{ dateStringFromISO8601(dro.end_date) }}
          </option>
        </select>
      </div>

      <div class="form-group" *ngIf="!getSelectedMembership().has_fixed_date_ranges">
        <label for="start-date">Start Date</label>
        <app-date-picker id="start-date"
                         [(content)]="lineItem.product_start_date"
                         [minDate]="minStartDate"></app-date-picker>
      </div>

      <div class="form-group" *ngIf="getSelectedMembershipAddOns().length > 0">
        Add-Ons
        <div class="form-check" *ngFor="let addOn of getSelectedMembershipAddOns()">
          <input class="form-check-input" type="checkbox"
                 id="addOnCheckbox{{ addOn.id }}"
                 [checked]="addOnIsSelected(addOn.id)"
                 (click)="toggleAddOn(addOn.id)">
          <label class="form-check-label" for="addOnCheckbox{{ addOn.id }}">
            {{ addOn.name }} ({{ orgConfigService.formatCurrency(addOn.fee) }})
          </label>
        </div>
      </div>

      <div class="form-group" *ngIf="getSelectedMembership().is_single_location">
        <label for="product_location_id">
          Membership Location
        </label>
        <select class="custom-select"
                id="product_location_id"
                name="product_location_id"
                [(ngModel)]="lineItem.product_location_id">
          <ng-container *ngIf="locationService.getLocations() !== null">
            <option *ngFor="let loc of locationService.getLocations()"
                    [ngValue]="loc.id">
              {{ loc.name }}
            </option>
          </ng-container>
        </select>
      </div>

    </ng-container>

    <div class="alert alert-danger" role="alert" *ngIf="errorMessage">
      {{ errorMessage }}
    </div>

  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary"
            (click)="activeModal.close()">
      Cancel
    </button>
    <button type="button" class="btn btn-primary"
            [disabled]="!allFieldsEntered()"
            [class.disabled]="!allFieldsEntered()"
            (click)="handleSubmit()"
            *ngIf="!loadingSubmit">
      Submit
    </button>
    <button type="button" class="btn btn-primary disabled" disabled
            *ngIf="loadingSubmit">
      Loading...
    </button>
  </div>

</ng-container>
